import { Pagination } from '../../../core/types/data';
import NetworkState from '../../../core/types/network';
import { ReduxAction, DispatchFunc } from '../../../core/types/redux';
import { DateFilter } from '../../../core/types/ux';
import { Patient } from '../patient/types';

export enum ResultActionConstants {
  INITIALIZE = '@@result/INITIALIZE',
  SEARCH_FILTER_SET = '@@result/SEARCH_FILTER_SET',
  PAGINATION_SET = '@@result/PAGINATION_SET',
  REQUEST_LIST_REQUEST = '@@result/REQUEST_LIST_REQUEST',
  REQUEST_LIST_SET = '@@result/REQUEST_LIST_SET',
}

export type TestStatus = 'process' | 'complete' | 'cancelled';

export interface SearchFilter {
  dateFilter: DateFilter;
  fromDate: Date;
  toDate: Date;
  searchValue?: string;
  status: 'all' | 'process' | 'complete';
}

export interface SetSearchFilterArgs {
  filter: SearchFilter;
  path: string;
  value: unknown;
  toRequest: boolean;
}

export interface SetPaginationArgs {
  pagination: Pagination;
}

export interface RequestRequestListOptions {
  filter: SearchFilter;
  pagination: Pagination;
}

export interface RequestRequestListArgs {
  options: RequestRequestListOptions;
}

export interface RequestListResult {
  requestLists: RequestInfo[];
  pagination: Pagination;
  count: number;
}

export interface SetRequestListArgs {
  requestListResult?: RequestListResult;
  error?: Error;
}

export interface RequestInfo {
  id: string;
  labNumber: string;
  patient?: Patient;
  age?: {
    year: number;
    month: number;
    day: number;
  };
  reqNumber?: string;
  reference?: {
    ref1?: string;
    ref2?: string;
  };
  placeId?: number;
  date?: Date;
  status?: TestStatus;
  testOrder?: RequestOrderInfo[];
}

export interface RequestOrderInfo {
  type?: string;
  name: string;
  status: TestStatus;
  packageDetails?: RequestOrderInfo[];
  flag?: boolean;
}

export type ResultAction<TArgs> = ReduxAction<TArgs, ResultActionConstants>;
export type ResultDispatchFunc<TArgs> = DispatchFunc<TArgs, ResultActionConstants>;

export interface ResultState {
  resultNetworkStates: {
    resultRequest: NetworkState;
  };
  isInitialized: boolean;
  currentPagination: Pagination;
  currentFilter: SearchFilter;
  requestLists?: RequestListResult;
}
